/**
 * Generates an ID safe for use as an HTML element id and CSS querySelector.
 * Starts with 4 random lowercase letters so the id never begins with a digit,
 * followed by a full UUID for uniqueness.
 */
export function generateAdElementId(): string {
    const prefix = Array.from(crypto.getRandomValues(new Uint8Array(4)))
        .map((b) => String.fromCharCode(97 + (b % 26)))
        .join('')
    return `${prefix}-${crypto.randomUUID()}`
}
